import React from "react";
import { Route, Routes } from "react-router-dom";
import Organisations from "./Organisations";
import SubUnits from "./SubUnits";
import Departments from "./Departments";
import Designations from "./Designations";
import Employees from "./Employees";

const OrganisationNestedRoute = () => {
  return (
    <Routes>
      <Route path="/organisations" element={<Organisations />} />
      <Route path="/subunits" element={<SubUnits />} />
      <Route path="/departments" element={<Departments />} />
      <Route path="/designations" element={<Designations />} />
      <Route path="/employees" element={<Employees />} />
    </Routes>
  );
};

export default OrganisationNestedRoute;
